<template>
<!-- <div></div> -->
<div class="card card-dashboard-progress" style="border-color: #cdd4e0;height:180px" v-loading='loading'>
    <div class="card bd-0 mg-t-0" style="height:180px;" v-show="isShow">
        <div class="card-header bd bd-b-0 tx-medium tx-black">
            {{title_detail}}
            <!-- <input v-model="message" placeholder="test"> -->
            <button type="button" class="close" aria-label="Close" style="float:right">
                <span aria-hidden="true" @click="isShow=!isShow">&times;</span>
            </button>
        </div><!-- card-header -->
        <div class="card-body bd bd-t-0" style="height:110px">
            <div class="table-responsive" style="height:110px" >
                <table class="table mg-b-0" style="height:100px;table-layout:fixed">
                    <thead>
                        <tr>
                            <th>Fund</th>
                            <th v-show="title_detail.includes('Corporate')">Trustee Name</th>
                        </tr>
                    </thead>
                    <tbody v-show="title_detail.includes('Corporate')">
                        <tr v-for='(cor,index) in cors' :key='cor.fund_code'>
                            <td class="tx-medium">
                                <router-link :to="{path:'/funddashboard/'+cor.fund_code,query:{name:cor.fund_name}}">
                                    {{isSample?'Sample Family Super Fund '+(index+1):cor.fund_name}}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{path:'/funddashboard/'+cor.fund_code+'/memberbasic/',query:{name:cor.fund_name,page:'Mamber Basic Details'}}">
                                    {{isSample?'Mr Mike Sample '+(index+1):cor.corporate_trustee_name}}
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-show="title_detail.includes('Individual')">
                        <tr v-for='(ind,index) in inds' :key='ind.fund_code'>
                            <td class="tx-medium">
                                <router-link :to="{path:'/funddashboard/'+ind.fund_code,query:{name:ind.fund_name,page:'Mamber Basic Details'}}">
                                    {{isSample?'Sample Family Super Fund '+(index+1):ind.fund_name}}
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div><!-- table-responsive -->
        </div><!-- card-body -->
    </div><!-- card -->
    <div class="card-body" v-show="!isShow">
        <div class="d-sm-flex justify-content-between mg-b-20">
            <label class="az-content-label tx-13 mg-b-10 mg-sm-b-0">Trustee Structure</label>
            <ul class="progress-legend">
                <li>Corporate</li>
                <li>Individual</li>
            </ul>
        </div>
        <div class="media mg-t-50" >
            <div class="media-body" style="margin-left:0">
                <div class="expansion-value">
                    <strong>{{cor_no}}
                        <a style="font-size:18px;color:gray" @click="cor_no>0 && showDetail('Funds - Corporate Trustees')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                    </strong>
                    <small>(Number of funds)</small>
                    <strong>{{ind_no}}
                        <a style="font-size:18px;color:gray" @click="ind_no>0 && showDetail('Funds - Individual Trustees')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                    </strong>
                </div>
                <div id="progressBar1" class="progress">
                    <div class="progress-bar bg-primary" aria-valuemax="100" :style="{'width':getPercentage(cor_no,cor_no+ind_no)}">{{getPercentage(cor_no,cor_no+ind_no)}}</div>
                    <div class="progress-bar bg-teal" aria-valuemax="100" :style="{'width':getPercentage(ind_no,cor_no+ind_no)}">{{getPercentage(ind_no,cor_no+ind_no)}}</div>
                </div>
                <div class="expansion-label">
                    <span>Corporate Trustees</span>
                    <span>Individual Trustees</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name:"structure",
    data(){
        return{
            isSample:false,
            cor_no:'',
            ind_no:'',
            cors:[],
            inds:[],
            isShow: false,
            title_detail:'',
            loading:true
        }
    },
    created(){
        this.getStructureData();
    },
    methods:{
        getStructureData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            let brand = localStorage.getItem('brand_code')
            this.isSample=userdetail['sample'];
            this.$api.adviserdashboard_api.trustee_structure(brand).then(response =>{
                //get the investments data from response
                this.cors = response.data['cor_funds']
                this.inds = response.data['ind_funds']
                this.cor_no = this.cors.length
                this.ind_no = this.inds.length
                this.loading=false
            })
        },
        getPercentage(value,total){
            return (value/total*100).toFixed(2)+'%'
        },
        showDetail(title){
            this.title_detail = title
            this.isShow = !this.isShow
            title==='BELOW AGE 50'? this.table_detail = this.age_lt_50
            :title==='AGED BETWEEN 50-60'? this.table_detail = this.age_50_60
            :title==='AGED BETWEEN 60-70'? this.table_detail = this.age_60_70
            :this.table_detail = this.age_gt_70

        }
    }
}
</script>
<style scoped>
.expansion-value{
    display: flex;
    justify-content: space-between;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: -.5px;
    margin-bottom: 5px;
    margin-top: auto;
}
.expansion-label{
    display: flex;
    justify-content: space-between;
    line-height: 1.5;
    font-weight: 400;
    font-size: 11px;
    color: #97a3b9;
    text-align: left;
}
</style>